/** Legacy landing URL — public visitors are redirected to {@link ORG_SIGN_IN_PATH}. */
export const MODULE_HUB_PATH = '/';

/** Authenticated fallback when no module home is resolved. */
export const APP_HOME_FALLBACK = '/dashboard/home';

/** Legacy choose-app URL — redirects to {@link ORG_SIGN_IN_PATH}. */
export const LEGACY_CHOOSE_APP_PATH = '/choose-app';

/** Generic organization login (not module-scoped). */
export const ORG_SIGN_IN_PATH = '/sign-in';

/** Legacy org login URL — redirects to {@link ORG_SIGN_IN_PATH}. */
export const LEGACY_MODULE_HUB_PATH = '/login';

/** Org self-service registration. */
export const REGISTER_PATH = '/register';

/** Legacy org signup URL — redirect to {@link REGISTER_PATH}. */
export const LEGACY_REGISTER_PATH = '/register';

/** Platform operator login (not linked from public routes). */
export const MASTER_SIGN_IN_PATH = '/master/login';
